import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { PageData } from "../../models/paging.model";

@Component({
    selector: 'pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit { 

    @Input() atSearchLimit: boolean = false;
    @Input() currentPage: PageData = { pageNumber: 1, resultsPerPage: 25 };

    @Output() pageChanged: EventEmitter<PageData> = new EventEmitter<PageData>();
    get pageNumber(): number {
        return this.currentPage.pageNumber;
    }
    set pageNumber(value: number) {
        this.currentPage.pageNumber = value;
    }

    resultOptions: number[] = [5, 10, 25, 50, 100];

    get totalPages(): string {
        let pages: string = "";
        if (this.currentPage != null && this.totalResults != null) {
            let rawPages = this.totalResults / this.currentPage.resultsPerPage;
            let rounded = Math.round(rawPages);
            if (rounded < rawPages) {
                rounded += 1;
            }
            pages = rounded.toString();
        }
        return pages;
    }

    @Input() totalResults: number;

    constructor() { }

    ngOnInit() {
    }

    next(): void {
        this.currentPage = { pageNumber: this.currentPage.pageNumber + 1, resultsPerPage: this.currentPage.resultsPerPage };
        this.pageChanged.emit(this.currentPage);
    }

    previous(): void {
        this.currentPage = { pageNumber: this.currentPage.pageNumber - 1, resultsPerPage: this.currentPage.resultsPerPage };
        this.pageChanged.emit(this.currentPage);
    }

    resultsChanged(): void {
        this.currentPage = { pageNumber: 1, resultsPerPage: this.currentPage.resultsPerPage };
        this.pageChanged.emit(this.currentPage);
    }
}
